module.exports = __webpack_public_path__ + "static/img/major_service_graduate.998223c5.jpg";